'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { initAnalytics } from '../../lib/analytics/posthog';
import { usePageTracking } from '../../lib/analytics/usePageTracking';
import { useScrollDepth } from '../../lib/analytics/useScrollDepth';
import { useTimeOnPage } from '../../lib/analytics/useTimeOnPage';

function getPageName(pathname) {
  if (pathname === '/') return 'Home';
  if (pathname === '/negocios') return 'Marketplace';
  if (pathname.startsWith('/negocios/') && pathname.includes('/servicios/')) return 'Service Detail';
  if (pathname.startsWith('/negocios/')) return 'Vendor Profile';
  if (pathname.startsWith('/directorio')) return 'Directory';
  if (pathname === '/signin') return 'Sign In';
  if (pathname === '/signup') return 'Sign Up';
  if (pathname === '/onboarding') return 'Onboarding';
  if (pathname.startsWith('/perfil')) return 'Profile';
  const segments = pathname.split('/').filter(Boolean);
  if (segments.length >= 1) return 'Category';
  return 'Other';
}

export default function AnalyticsProvider({ children }) {
  useEffect(() => {
    // PostHog is already dynamically imported and queues events until it is
    // ready. Start it when the main thread is idle so its SDK and exception
    // plugins do not compete with the mobile LCP; the timeout guarantees that
    // tracking still starts promptly on continuously busy pages.
    if ('requestIdleCallback' in window) {
      const idleId = window.requestIdleCallback(() => initAnalytics(), { timeout: 2000 });
      return () => window.cancelIdleCallback(idleId);
    }

    const timeoutId = window.setTimeout(() => initAnalytics(), 1000);
    return () => window.clearTimeout(timeoutId);
  }, []);

  const pathname = usePathname();
  const pageName = getPageName(pathname);
  usePageTracking();
  useScrollDepth(pageName);
  useTimeOnPage(pageName);

  return children;
}
